module.exports = __webpack_public_path__ + "img/empty@3x.8d85a73e.png";